const fieldsInfo = {};

const tabs = [
  {
    title: 'Información General',
    fields: [
      'serie',
      'tarjeta_de_circulacion',
      'numero_de_calcomania',
      'clave_nacional',
      'unidad_de_recaudacion',
      'observaciones',
      'fecha_del_ultimo_movimiento',
      'tipo_de_tramite_vehicular',
    ],
  },
  {
    title: 'Información de la Motocicleta',
    fields: [
      'es_vehiculo_nacional',
      'pais',
      'es_fronterizo',
      'marca',
      'modelo',
      'linea',
      'tipo',
      'estatus_del_vehiculo',
      'servicio',
      'numero_de_motor',
      'descripcion_de_la_agencia',
      'color_del_vehiculo',
      'color_secundario',
      'capacidad_del_combustible',
      'uso_de_la_motocicleta',
      'cilindraje',
      'capacidad_del_cilindraje',
      'peso_del_vehiculo',
      'numero_de_ruedas',
      'tipo_de_combustible',
    ],
  },
  {
    title: 'Facturación',
    fields: [
      'clave_del_documento_de_regularizacion',
      'importe_de_la_factura',
      'fecha_de_la_factura',
      'numero_de_factura',
      'registro_publico_vehicular',
      'observaciones_de_factura',
    ],
  },
];

const configs = {
  // Información General
  serie: {
    formItemProps: {
      label: 'Serial',
      required: true,
    },
    controlProps: {
      maxLength: 40,
    },
  },
  tarjeta_de_circulacion: {
    formItemProps: {
      label: 'Número de Tarjeta de Circulación',
    },
  },
  numero_de_calcomania: {
    formItemProps: {
      label: 'Número de Calcomanía',
    },
  },
  clave_nacional: {
    formItemProps: {
      label: 'Clave Nacional',
    },
  },
  unidad_de_recaudacion: {
    formItemProps: {
      label: 'Unidad Recaudadora',
      required: true,
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
  },
  fecha_del_ultimo_movimiento: {
    formItemProps: {
      label: 'Fecha del último movimiento',
    },
  },
  tipo_de_tramite_vehicular: {
    formItemProps: {
      label: 'Fecha del último movimiento',
    },
  },
  // Información de la Motocicleta
  es_vehiculo_nacional: {
    formItemProps: {
      label: '¿Es Nacional?',
    },
    hideOnTruty: ['pais'],
  },
  pais: {
    fkListIsPaginated: true,
    formItemProps: {
      label: 'Pais',
      required: true,
    },
  },
  es_fronterizo: {
    formItemProps: {
      label: '¿Es Fronterizo?',
    },
  },
  marca: {
    fkListIsPaginated: true,
    formItemProps: {
      label: 'Marca',
      required: true,
    },
  },
  modelo: {
    formItemProps: {
      label: 'Modelo',
      tooltip: 'Año del vehículo',
    },
  },
  linea: {
    formItemProps: {
      label: 'Línea',
      required: true,
    },
  },
  tipo: {
    formItemProps: {
      label: 'Tipo de Motocicleta',
    },
  },
  estatus_del_vehiculo: {
    formItemProps: {
      label: 'Estatus de la motocicleta',
      required: true,
    },
    controlProps: {
      labelProp: 'nombre',
    },
  },
  servicio: {
    formItemProps: {
      label: 'Servicio',
      required: true,
    },
    controlProps: {
      labelProp: 'nombre',
    },
  },
  numero_de_motor: {
    formItemProps: {
      label: 'Número de motor',
    },
  },
  descripcion_de_la_agencia: {
    formItemProps: {
      label: 'Agencia Distribuidora',
    },
  },
  color_del_vehiculo: {
    formItemProps: {
      label: 'Color',
      required: true,
    },
  },
  color_secundario: {
    formItemProps: {
      label: 'Color Secundario',
    },
  },
  capacidad_del_combustible: {
    formItemProps: {
      label: 'Capacidad del Tanque',
      tooltip: 'Capacidad en litros',
    },
  },
  uso_de_la_motocicleta: {
    formItemProps: {
      label: 'Uso de la Motocicleta',
      required: true,
    },
  },
  cilindraje: {
    formItemProps: {
      label: 'Cilindraje',
    },
  },
  capacidad_del_cilindraje: {
    formItemProps: {
      label: 'Capacidad del Cilindraje',
      tooltip: 'Capacidad del Cilindraje en cm³',
    },
  },
  peso_del_vehiculo: {
    formItemProps: {
      label: 'Peso de la Motocicleta',
      tooltip: 'Peso en Kilogramos',
    },
  },
  numero_de_ruedas: {
    formItemProps: {
      label: 'Número de Ruedas',
    },
  },
  tipo_de_combustible: {
    formItemProps: {
      label: 'Tipo de Combustible',
      required: true,
    },
  },
  // Facturación
  clave_del_documento_de_regularizacion: {
    formItemProps: {
      label: 'Clave de Documento',
    },
  },
  importe_de_la_factura: {
    formItemProps: {
      label: 'Importe de la factura',
    },
  },
  fecha_de_la_factura: {
    formItemProps: {
      label: 'Fecha de la factura',
      required: true,
    },
  },
  numero_de_factura: {
    formItemProps: {
      label: 'Número de factura',
      required: true,
    },
  },
  registro_publico_vehicular: {
    formItemProps: {
      label: 'Registro Público Vehicular',
    },
    controlProps: {
      maxLength: 17,
    },
  },
  observaciones_de_factura: {
    formItemProps: {
      label: 'Observaciones de Factura',
    },
  },
};

const forbiddenProps = [
  'numero_de_placa_vigente',
];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
